<template>
  <div class="hello">
    	<div class="common_header_nav">
          <div class="panel_userdata">
            <div>
              欢迎，<strong>{{login_nickname}}</strong>&nbsp;
              <el-tag type="success" v-if="login_power == '2'" size="mini" Plain>管理员</el-tag>
              <el-tag type="success" v-if="login_power == '3'" size="mini" Plain>普通用户</el-tag>
            </div>
            <div class="panel_userdata_company">{{login_company}}</div>
            <el-link class="exit_backyard" type="danger"  @click="handleExit" icon="el-icon-switch-button">退出系统</el-link>
          </div>
				</div>
  </div>
</template>

<script>

import * as MN from '@/api/common'

export default {
  name: 'common-header',
  props: {
    msg: String,
    selec:String
  },
  data(){
    return{
      login_power:'',
      login_company:'',
      login_nickname:''
    }
  },
  created() {
		this.handleLoginUser()
	},
  methods:{
    handleExit(){
      let me = this;
      let post={
					token:sessionStorage.getItem('subudian_token')
      }
      MN.loginOut(post).then(res => {
        if( res.status == 'ok' ){
          me.$message({
            message: '已退出系统',
            type: 'warning'
          });
          location.href="https://www.subudian.com";
        }
			})
    },
    handleLoginUser(){
      let me = this;
      let post={
					token:sessionStorage.getItem('subudian_token')
      }
      MN.loginUserdata(post).then(res => {
        if( res.status == 'token_out' ){
          me.handleExit();
          me.$message({
            message: '请重新登录系统',
            type: 'warning'
          });
        }
        me.login_power = res.u_power
        me.login_nickname = res.u_nickname
        me.login_company = res.u_company
				console.log(res)
			})
    },
  }
}
</script>

<style scoped>
  .exit_backyard{ position: absolute;  right: 0; top:8px; }
  .panel_userdata{ position: relative; font-size: 13px; padding-right: 90px;  }
  .panel_userdata_company{ color: #a2a2a2; margin-top: 4px; }
</style>
